module.exports = __webpack_public_path__ + "header_new_one.0eb1363beec30d9363dc.jpg";


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src154282656/src/www-arthcloud/src/assets/images/landing/header_new_one.jpg
// module id = ../../../../../src/assets/images/landing/header_new_one.jpg
// module chunks = 2